export default __webpack_public_path__ + "c617c85203646a9b16b60d8db0f8ed5a.wav";